import { useState } from 'react';
import { useSnackbar } from 'notistack';

import { createCompany, editCompany } from '../../../../crud/companies.crud';
import { ICompanyAddProps, ICompanyEditProps } from '../../../../interfaces/companies';
import { useFormatMessage } from '../../../../hooks';
import { getResponseMessage } from '../../../../utils/utils';

export const useCompany = () => {
  const fm = useFormatMessage();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const add = async (data: ICompanyAddProps) => {
    setLoading(true);
    createCompany(data)
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  };

  const edit = async (id: number, data: ICompanyEditProps) => {
    editCompany(id, data)
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  };

  return {
    loading,
    success,
    add,
    edit,
  };
};
